import {PricingPrice} from "./PricingPrice";
import {PricingOriginalDTO} from "./dto/PricingDTO";

export class PricingOriginal
{
    private readonly _price: PricingPrice

    constructor(original: PricingOriginalDTO) {
        if(original) {
            this._price = new PricingPrice(original.price );
        }
    }

    get price(): PricingPrice {
        return this._price;
    }
}
